import {
  useMemo,
  useState,
} from 'react';
import { createPortal } from 'react-dom';
import { useSearchParams } from 'react-router-dom';

import {
  useAuth,
  useCases,
  useTownAssets,
} from '../stores';
import { qrCodeLabelOnly } from '../views/Qrs/utils';

import SupportForm from './SupportForm';
import SvgColorImg from './SvgColorImg';

const SupportButton = function SupportButton() {
  const { assets } = useTownAssets();
  const { auth } = useAuth();
  const { cases } = useCases();
  const [searchParams] = useSearchParams();
  const [supportOpen, setSupportOpen] = useState(false);
  const {
    translate,
  } = assets;

  // The case open on screen, offered as the subject of a support request to admins
  const selectedCsid = searchParams.get('cs');
  const isAdmin = ['admin', 'super'].some((privilege) => auth.info?.privlg?.includes(privilege));
  const supportCase = useMemo(
    () => {
      if ((!isAdmin) || (!selectedCsid)) return null;
      const thisCase = cases.all?.find((candidate) => (candidate.csid === selectedCsid));
      if (!thisCase) return null;
      const qrLabel = thisCase.csObject?.qrType ? ` - ${qrCodeLabelOnly(translate, thisCase.csObject)}` : '';
      return {
        csid: thisCase.csid,
        csUid: thisCase.csUid,
        label: `${translate(thisCase.ccatCode, 'userMainMenu')}${qrLabel}`,
      };
    },
    [isAdmin, selectedCsid, cases.all, translate],
  );

  return (
    <>
      <button
        type="button"
        onClick={() => setSupportOpen(true)}
        className="text-pxMainMenuItem text-sm py-1 hover:text-pxMainMenuItemSel shrink-0 relative z-10 flex flex-row items-center gap-2"
        id="supportLink"
      >
        <SvgColorImg
          src="/images/svg/gui/helpDesk.svg"
          description={translate('noServerConnection', 'statements')}
          className="w-4 h-4 fill-pxMainMenuItem"
          imgColorAsCssFill
        />
        {translate('helpDesk')}
      </button>

      {/* Portalled: the side menu's stacking context would put the popup under the main area */}
      {(supportOpen)
        ? createPortal(<SupportForm onClose={() => setSupportOpen(false)} supportCase={supportCase} />, document.body)
        : null}
    </>
  );
};

export default SupportButton;
